import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { DateTime } from 'luxon';

import { getEventDateLabel } from '../../../../pro/views/AlbumFolder/FreemiumEvents/SpecialtyAlbumGreetingModal/helpers';

const propTypes = {
  albumFolder: PropTypes.shape({
    id: PropTypes.string,
  }),
  className: PropTypes.string,
};

const WebGalleryAlbumFolderHeader = ({ albumFolder, className }) => {
  const classes = classNames({
    'web-gallery-album-folder-title-wrapper': true,
    [className]: !!className,
  });

  const eventDateLabel = getEventDateLabel(albumFolder, DateTime.DATE_MED);

  return (
    <div className={classes}>
      {!albumFolder.parent && (
        <p className="web-gallery-album-folder-welcome">Welcome to</p>
      )}
      <h2 className="web-gallery-album-folder-title">{albumFolder.name} </h2>
      {eventDateLabel && (
        <p className="text-black text-dark text-sm">{eventDateLabel}</p>
      )}
    </div>
  );
};

WebGalleryAlbumFolderHeader.propTypes = propTypes;

export default WebGalleryAlbumFolderHeader;
